<h1 mat-dialog-title>Upload prescription</h1>
<div mat-dialog-content>
  <p class="dialog-hint">Order #{{ data.orderId }}. Choose a PDF and upload it to complete this prescription file.</p>
  <core-file-uploader
    [accept]="data.acceptFiles"
    [orderId]="data.orderId"
    (onFileUploaded)="onUploadComplete($event)"
  ></core-file-uploader>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>